import { render, staticRenderFns } from "./dataPrivilegeUnit.vue?vue&type=template&id=ee2b0106&scoped=true"
import script from "./dataPrivilegeUnit.vue?vue&type=script&lang=js"
export * from "./dataPrivilegeUnit.vue?vue&type=script&lang=js"
import style0 from "./dataPrivilegeUnit.vue?vue&type=style&index=0&id=ee2b0106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2b0106",
  null
  
)

export default component.exports